export const Browser = (() => {
  /*
      What browsers use documentMode?
  
      This will work for all Non IE browsers
      Number.MAX_VALUE.
  
      But we don't want opera mini
  
      Do we consider putting in the message component in a <no-script> 
      to deal with opera mini?
  
    this will detect old Edge and Ie, but won't work if it's operat mini, it uses this
  
    var isOldEdgeOrIE = !('reversed' in document.createElement('ol'));
    
    */
  //Detect IE 11 and down.
  //https://www.w3schools.com/jsref/prop_doc_documentmode.asp
  const hasDocumentMode = document.documentMode ? true : false;

  //reversed is not present in IE or Old Edge
  //https://stackoverflow.com/questions/56360225/how-to-detect-microsoft-chromium-edge-chredge-edgium-in-javascript
  const isOldEdgeOrIE = !("reversed" in document.createElement("ol"));

  //We don't want to use opera mini.
  //http://www.javascriptkit.com/javatutors/navigator.shtml
  const isOperaMini = window.operamini ? true : false;

  //This method has never been implemented in IE of any version
  //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number
  const hasNumberParseInt = Number.parseInt ? true : false;

  let isModern = true;
  //check if it's opera mini.
  if (isOperaMini) {
    isModern = false;
  } else if (isOldEdgeOrIE) isModern = false;
  else if (hasDocumentMode) {
    //This is specific to IE, but also a fail safe against opera mini not being present in the window ojb, if opera changes things
    isModern = false;
  } else if (!hasNumberParseInt) {
    isModern = false;
  }
  
  return { isModern };
})();
